import React, {useCallback, useContext, useEffect, useRef, useState} from "react";
import videojs from "video.js";
import "../videojs/plugins/hlsjs";
import "../videojs/player";
import "../videojs/plugins/watermark";
import "../videojs/plugins/pills";
import "../videojs/plugins/sponsors";
import "../videojs/plugins/pre-roll";
import "../videojs/plugins/keyboard";
import "../videojs/plugins/toasts";
//import "../videojs/plugins/resolution-swithcer";
import "../videojs/plugins/fullscreen";
import "../videojs/plugins/subscription";
import "../videojs/plugins/videojs.airplay.js";
//import "video.js/dist/video-js.css";
//import "../videojs/skins/jwlike/videojs.css"
import {MyContext} from "../contexts/MyContext";

export const VideoJS = ( {options, onReady} ) => {
    const videoRef = useRef(null);
    const playerRef = useRef(null);
    const {videoId, liveId } = options;
    const { addStatisticRecord } = useContext(MyContext);
    const [novaPlayerReady, setNovaPlayerReady] = useState(false);

    useEffect(() => {
        if (!playerRef.current) {

            const videoElement = document.createElement("video-js");
            videoElement.classList.add('vjs-default-skin', 'vjs-big-play-centered');
            videoElement.setAttribute("muted", true);
            videoRef.current.appendChild(videoElement);


            options.plugins = {
                keyboard: {}
            }

            options.language = 'en';
            options.languages = {
                en: {
                    "Quality video": "Quality",
                    "Set quality to Auto": "Auto",
                    "Set quality to 1080": "HIGH",
                    "Set quality to 720": "MED",
                    "Set quality to 360": "LOW",
                    "Auto quality": "Auto",
                }
            }

            const player = playerRef.current = videojs(videoElement, {...options,  muted: true},  () => {
                window.videojs = videojs;

                var script = document.createElement("script");
                script.src = "/script/chromecast.min.js";
                document.body.appendChild(script);
                script.onload = () => {
                    player.chromecast({button: "controlbar"});
                };
                onReady && onReady(player);
            });

        } else {
            const player = playerRef.current;
            player.autoplay(options.autoplay);
            player.poster(options.poster);
            player.src(options.sources);
            if (options.sources && novaPlayerReady) {
                player.changeSource({sources: options.sources})
            }

            player.on("novaReady", async () => {
                setNovaPlayerReady(true);
            })
            player.ads = options.ads;

        }

        return () => playerRef?.current?.off("novaReady")

    }, [options, videoRef, novaPlayerReady]);

    // Dispose the Video.js player when the functional component unmounts
    useEffect(() => {
        if (playerRef.current) {
            const player = playerRef.current;

            player?.on("ready", function(){
                updateStatistic()
            });

            return () => {
                if (player) {
                    player.dispose();
                    playerRef.current = null;
                }
            };
        }
        // eslint-disable-next-line
    }, [playerRef]);

    const updateStatistic = useCallback(() => {
        if (videoId || liveId) {
            addStatisticRecord(videoId, liveId);
        }
    }, [videoId, liveId])

    //playsinline -> disabled opening full screen when user click play on iOS devises
    return (
        <div data-vjs-player className="video" id="video">
            <div ref={videoRef} className="h-100 w-100"/>
        </div>
    );
};

export default VideoJS;